var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDau = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "currentColor"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-dau_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m17.61 8.413-.41-.894h-3.373l-.41.894a1 1 0 0 1-1.818-.831l2.641-5.777c.499-1.09 2.048-1.09 2.547 0l2.641 5.777a1 1 0 1 1-1.819.831M15.513 3.83l.772 1.689h-1.545z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.536 12.06a1 1 0 1 1 2 0v6.984h-2zM4.509 13.202a1 1 0 0 0-1 1v4.842h2V14.2a1 1 0 0 0-1-1M1.48 15.99a1 1 0 0 0-1 1v2.054h2V16.99a1 1 0 0 0-1-1M12.885 11.068a1 1 0 0 1 1 1v3.414a1.629 1.629 0 1 0 3.257 0v-3.414a1 1 0 0 1 2 0v3.414a3.629 3.629 0 0 1-7.257 0v-3.414a1 1 0 0 1 1-1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M.888 7.817a1.2 1.2 0 0 0 1.2 1.2h1.556q1.356 0 2.37-.431a3.47 3.47 0 0 0 1.6-1.343q.57-.898.57-2.278t-.57-2.254q-.572-.887-1.628-1.305-1.043-.42-2.47-.42H2.087a1.2 1.2 0 0 0-1.2 1.2zm2.3-.266a.2.2 0 0 1-.2-.2V2.652c0-.11.089-.2.2-.2h.199q.8 0 1.385.234.6.222.928.776.328.542.328 1.503T5.7 6.492a1.87 1.87 0 0 1-.928.813q-.585.246-1.385.246z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-dau_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgIconDau;